import React from "react";
import { Helmet } from "react-helmet-async";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LeadFormAndWidgetWrapper from "../lead-form-and-widget-wrapper";
import { Heading } from "@cars24/turbo-web/lib/heading";
import {  NUMBER } from "../../../constants/app-constants";
import { COLOR_TOKEN } from "../../../constants/scrap-cars-constants";

const ScrapCarBanner = ({
    heading = "",
    subHeading = "",
    homePageBanner = "",
    altText = ""
}) => {
    return (
        <div styleName={"styles.scrapCarBanner"}>
            <Helmet>
                <link
                    rel="preload"
                    href={homePageBanner}
                    imageSrcSet={homePageBanner}
                    as={"image"}
                    type="image/png"
                    fetchpriority="high"
                />
            </Helmet>
            <div styleName={"styles.scrapCarText"}>
                <div styleName={"styles.bannerSection"}>
                    <div>
                        <Heading level={NUMBER.FOUR} isBold color={COLOR_TOKEN.greenPrimary}>{heading}</Heading>
                        <Heading level={NUMBER.ONE} isBold>{subHeading}</Heading>
                    </div>
                    <img src={homePageBanner} alt={altText} />
                </div>
                <div styleName={"styles.leadFormWrapper"}>
                    <LeadFormAndWidgetWrapper
                        ctaText={"GET PRICE"}
                        isBrandsVisible={false}
                        isScrapBenefitsVisible={true}
                        isDlsCompliant
                    />
                </div>
            </div>
        </div>
    );
};

ScrapCarBanner.propTypes = {
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    homePageBanner: PropTypes.string,
    altText: PropTypes.string
};

export default ScrapCarBanner;
